//*Libraries imports
import Request from "../../Request";

export default class InscricoesCriteriosAssinaturasManager {
  static async Get(page = 1) {
    return await Request.Get(
      `inscricoes/criterio-selecao-assinaturas?page=${page}`,
    );
  }

  static async Store(data) {
    return await Request.Post(`inscricoes/criterio-selecao-assinaturas`, data);
  }

  static async Update(id, data) {
    return await Request.Post(
      `inscricoes/criterio-selecao-assinaturas/${id}`,
      data,
    );
  }

  static async ShowByKey(key) {
    return await Request.Get(
      `inscricoes/criterio-selecao-assinaturas/key/${key}`,
    );
  }

  static async Delete(id) {
    return await Request.Delete(
      `inscricoes/criterio-selecao-assinaturas/${id}`,
    );
  }

  static async DownloadTestCertificate(key) {
    return await Request.PostFile(
      `inscricoes/criterio-selecao-assinaturas/test-certificate/${key}`,
      null,
    );
  }
}
